// extracted by mini-css-extract-plugin
export default {"services":"ServiceContent_services__AfjJ8","services_box":"ServiceContent_services_box__+RIIA","services_content":"ServiceContent_services_content__xxivE"};